import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'product_tile-brand_hover_card-action_category_click';

/**
 * Track when a user clicks inside the brand hover card shown on discovery product tiles.

Params:
1. request ID
2. product token holding the card
3. brand token
4. specific component inside the card that was clicked
5. placeholder
 */
export function trackProductTileBrandHoverCardActionCategoryClick(
  requestID: string,
  productToken2: string,
  brandToken3: string,
  clickTarget4: string,
  param55: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: {
      requestID,
      productToken2,
      brandToken3,
      clickTarget4,
      param55,
    },
  });
}
